import React, { useState } from 'react';
import "../Navbar/Header.css";
import logo from "../../Images/Woodsy.png";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useLocation } from 'react-router-dom';
import { ImUser } from "react-icons/im";
import { Badge } from 'antd';
import { IoMdCart } from "react-icons/io";
import { IoSearch } from "react-icons/io5";
import { BiSolidUser } from "react-icons/bi";
const Header = () => {
    const location = useLocation();
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [token, setToken] = useState("")

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };
    return (
        <div>
            <div className='navbar-main-head-con'>
                <Navbar collapseOnSelect expand="lg" className="">
                    <Container>
                        <Navbar.Brand href="#home" className="header-logo-brand-main-con">
                            <div className='header-logo-mai-con'>
                                <div className='header-logo-con'>
                                    <img src={logo} />
                                </div>
                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav" className="custom-navbar-collapse">
                            <Nav className="custom-navbar-links-con">
                                <Nav.Link as={Link} to="/" className={location.pathname === "/" ? "active-link" : ""}>Home</Nav.Link>
                                <Nav.Link as={Link} to="/product" className={location.pathname === "/product" ? "active-link" : ""}>Product</Nav.Link>
                                <Nav.Link as={Link} to="/about" className={location.pathname === "/about" ? "active-link" : ""}>About</Nav.Link>
                                <Nav.Link as={Link} to="/contact" className={location.pathname === "/contact" ? "active-link" : ""}>Contact</Nav.Link>
                                <Nav.Link as={Link} to="/terms-conditions" className={location.pathname === "/terms-conditions" ? "active-link" : ""}>Terms & Conditions</Nav.Link>
                                <Nav.Link as={Link} to="/return-policy" className={location.pathname === "/return-policy" ? "active-link" : ""}>Return Policy</Nav.Link>
                                <Nav.Link as={Link} to="/shipping" className={location.pathname === "/shipping" ? "active-link" : ""}>Shipping</Nav.Link>
                                <Nav.Link as={Link} to="/return-policy" className={location.pathname === "/return-policy" ? "active-link" : ""}>Return Policy</Nav.Link>
                            </Nav>
                            <Nav className="custom-navbar-nav">
                                <div className='Header-Icons-Main-con'>
                                    <div className='Header-Icons-con'>
                                        <div className='Header-Profile-Icons-Con-search' onClick={toggleSearch}>
                                            <IoSearch />
                                        </div>
                                        <div className='Header-Profile-Icons-Con'>
                                            <Link to={token ? "/order" : "/account/sign-in"}>
                                                <button title={token ? "order" : "/account/sign-in"}>
                                                    <BiSolidUser />
                                                </button>
                                            </Link>
                                        </div>
                                        <div className='Header-Profile-Icons-Con'
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasRight"
                                            aria-controls="offcanvasRight">
                                            <Badge size="small"
                                            // count={cartValue.length}
                                            >
                                                <IoMdCart />
                                            </Badge>
                                        </div>
                                    </div>
                                </div>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
        </div>
    )
}

export default Header
